import { actionTypes } from "../actions/schedule";

const initialState = {
  scheduleResults: null,
  scheduleError: null,
  isRouteScheduling: false,
  open: false,
  optimise: null,
  isRetryEnabled: true,
  isSaveEnabled: true,
};

const schedule = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SCHEDULE_ROUTE_START:
      return {
        ...state,
        open: true,
        isRouteScheduling: true,
      };
    case actionTypes.SCHEDULE_ROUTE_SET_OPTIMISE:
      return {
        ...state,
        optimise: payload,
      };
    case actionTypes.SCHEDULE_ROUTE_COMPLETE:
      return {
        ...state,
        isRouteScheduling: false,
        scheduleResults: payload,
        scheduleError: null,
      };
    case actionTypes.SCHEDULE_ROUTE_ERROR:
      return {
        ...state,
        isRouteScheduling: false,
        scheduleError: payload.error,
        isSaveEnabled: payload.isSaveEnabled,
        isRetryEnabled: payload.isRetryEnabled,
      };
    case actionTypes.SCHEDULE_ROUTE_CLOSE:
      return initialState;
    default:
      return state;
  }
};

export default schedule;
